import { messages } from './messages'

export const BENEFITS = [
  {
    label: messages.benefits.sum.label,
    value: messages.benefits.sum.value,
  },
  {
    label: messages.benefits.speed.label,
    value: messages.benefits.speed.value,
  },
  {
    label: messages.benefits.returned.label,
    value: messages.benefits.returned.value,
  },
]
